import { opsZoneDetails, type OpsZoneState } from './opsZoneDetails/opsZoneDetails';

export default {
  namespaced: true,
  state: {
    ...opsZoneDetails,
  },
  mutations: {
    populateOpsZone(state: OpsZoneState, opsZoneResponse: Record<string, any>) {
      const keys = Object.keys(state.currentOpsZone);
      keys.forEach((key) => {
        (state.currentOpsZone as Record<string, any>)[key] = opsZoneResponse[key];
      });
      state.currentOpsZone.zoneWeekDays = opsZoneResponse.zoneWeekDays.splice(-1).concat(state.currentOpsZone.zoneWeekDays);
    },
    clearOpsZone(state: OpsZoneState) {
      Object.assign(state, JSON.parse(JSON.stringify(opsZoneDetails)));
    },
  },
  getters: {
    getCurrentOpsZone: (state: OpsZoneState) => state.currentOpsZone,
    getVehicleCategories: (state: OpsZoneState) => state.currentOpsZone.vehicleCategories,
    getRideTypes: (state: OpsZoneState) => state.currentOpsZone.shuttleType,
    getAvailableShuttleType: (state: OpsZoneState) => state.currentOpsZone.shuttleType,
    getMaxNumberOfDaysForFutureBooking: (state: OpsZoneState) => state.currentOpsZone.maxNumberOfDaysForFutureBooking,
    getMinTimeBeforeBooking: (state: OpsZoneState) => state.currentOpsZone.minTimeBeforeBooking,
    getWorkingHoursZoneWeekDays: (state: OpsZoneState) => state.currentOpsZone.zoneWeekDays,
    getHolidays: (state: OpsZoneState) => state.currentOpsZone.holidays,
    isOpsZoneSelected: (state: OpsZoneState) => state.currentOpsZone.opsZoneId,
    getTimeZone: (state: OpsZoneState) => state.currentOpsZone.timeZone,
    isOnBoardPaymentAllowed: (state: OpsZoneState) => state.currentOpsZone.onBoardPaymentAllowed,
    allowOnDemandPickUpTime: (state: OpsZoneState) => state.currentOpsZone.allowOnDemandPickUpTime,
    isFreeTrip: (state: OpsZoneState) => state.currentOpsZone.isFreeTrip,
    getCountry: (state: OpsZoneState) => state.currentOpsZone.country,
  },
};
